import { Logout, Settings } from '@mui/icons-material';
import { Avatar, Divider, ListItemAvatar, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Image } from 'app/components';
import { useAsyncAction } from 'app/services';
import { sessionSignOut } from 'app/store/session';
import React from 'react';
import { useSelector } from 'react-redux';

const AccountMenu = (props) => {
  const { open, onClose, anchorEl } = props;
  const { session } = useSelector((state) => state.session);
  const { asyncAction: submit } = useAsyncAction(sessionSignOut);

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      PaperProps={{
        sx: (theme) => ({
          minWidth: '240px',
          marginLeft: '12px',
          boxShadow: '0px 3px 6px ' + alpha(theme.palette.grey.main, 0.12),
          borderTopRightRadius: '0',
          borderTopLeftRadius: '0',
          borderTop: '0',
          '&:before': {
            display: 'none',
          },
          '.MuiListItemAvatar-root': {
            minWidth: '44px',
          },
          '.MuiListItemIcon-root': {
            minWidth: '32px !important',
          },
          '.MuiMenuItem-root': {
            padding: theme.spacing(1, 2),
            '&:nth-of-type(2)': {
              display: 'none',
            },
            '&:first-of-type:hover': {
              cursor: 'default',
              bgcolor: 'inherit',
            },
          },
        }),
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}>
      <MenuItem disableGutters disableRipple>
        <ListItemAvatar>
          <Avatar>
            <Image name={`avatar-${session.role_id}.png`} alt={`avatar-${session.role_id}`} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={session.name} secondary={session.email} />
      </MenuItem>
      <Divider />
      <MenuItem>
        <ListItemIcon>
          <Settings fontSize='small' />
        </ListItemIcon>
        Настройки
      </MenuItem>
      <MenuItem onClick={submit}>
        <ListItemIcon>
          <Logout fontSize='small' />
        </ListItemIcon>
        Выход
      </MenuItem>
    </Menu>
  );
};

export default AccountMenu;
